import { v4 } from 'uuid'

/**
 * A v4 uuid on every platform this package runs on.
 *
 * `uuid`'s browser build — the one React Native resolves — throws
 * "crypto.getRandomValues() not supported" on Hermes, which has no WebCrypto
 * and no polyfill unless the host app installs one. These ids are idempotency
 * and correlation keys rather than secrets, so falling back to `Math.random`
 * beats crashing a withdrawal mid-flight.
 */
export function randomUuid(): string {
  return hasWebCrypto() ? v4() : v4({ rng: mathRandomBytes })
}

function hasWebCrypto(): boolean {
  const webCrypto = (
    globalThis as {
      crypto?: { getRandomValues?: (b: Uint8Array) => Uint8Array }
    }
  ).crypto
  return typeof webCrypto?.getRandomValues === 'function'
}

function mathRandomBytes(): Uint8Array {
  const bytes = new Uint8Array(16)
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = Math.floor(Math.random() * 256)
  }
  return bytes
}
